import {useMemo} from 'react';

import {getFilledRegex} from '../utils/regex';
import {useQuickAddKeys} from './useQuickAddKeys';

export type MultiMetricPanelsMap = Map<string, {metrics: string[]}>;

/**
 * Given a regex pattern, returns a map of panels to add for multi-metric quick add.
 * Map key is the panel's regex pattern, and value contains matching metrics.
 */
export const useMultiMetricPanelsMap = (
  regex: string,
  isRegexValid: boolean
): MultiMetricPanelsMap => {
  const {searchedKeys: matchedKeys} = useQuickAddKeys(regex, 'number');

  return useMemo(() => {
    const map: MultiMetricPanelsMap = new Map();

    if (!regex || !isRegexValid) {
      return map;
    }

    matchedKeys.forEach(([key]) => {
      const filledRegex = getFilledRegex(key, regex);

      if (!filledRegex) {
        return;
      }

      const existing = map.get(filledRegex);
      if (existing) {
        existing.metrics.push(key);
      } else {
        map.set(filledRegex, {
          metrics: [key],
        });
      }
    });

    return map;
  }, [regex, isRegexValid, matchedKeys]);
};
